import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(private readonly router: Router) { }
  private _errorPageImage: string;
  isUnauthorized: boolean = false;

  ngOnInit(): void {
    if (this.router.url === '/userNotValid') {
      this.isUnauthorized = true;
    }
  }

  get errorPageImage(): string {
    const isDark = sessionStorage.getItem('theme') === 'dark';
    if (this.isUnauthorized) {
      this._errorPageImage = isDark
        ? './assets/images/page-403-dark.svg'
        : './assets/images/page-403-light.svg';
    } else {
      this._errorPageImage = isDark
        ? './assets/images/empty-state-dark.svg'
        : './assets/images/empty-state-light.svg';
    }

    return this._errorPageImage;
  }
}

